import { Slugify } from '../../Admin/Functions/Slugify.js';

export const FilterOriginsType = (datas) => {
    const collection = [];
    const map = new Map();
    if (!datas.errno) {
        for (const el of datas) {
            if (!map.has(el.otname)) {
                map.set(el.otname, true);
                collection.push({
                    otid: el.otid,
                    otslug: Slugify(el.otname),
                    otname: el.otname,
                });
            }
        }
    }
    return collection;
}
